import API, { API_URL } from 'api/API';

import { ApiResult } from 'libs/types';

interface GetMoonInfoApiResult extends ApiResult {
  time_utc: string;
  age: number;
}

async function getMoonInfoApi(): Promise<GetMoonInfoApiResult> {
  const { data } = await API.get(`${API_URL.COMMON.GET_MOON_INFO}`);

  return data;
}

export default getMoonInfoApi;
